import SideBareMagasin from "../SideBareMagasin/SideBareMagasin";
import { Link, useParams } from "react-router-dom";
import { ArticleInfo } from "../../../Modeles/ArticleModel";
import { useContext, useEffect, useState } from "react";
import AfficheArticleInMagasin from "../../../Services/Magasin/AfficheArticleInMagasin";
import { MagasinContext } from "../../../Context/MagasinContext";
import axios from "axios";
import { NewSideBarMagasins } from "../../NewSidebarMagasin";/* ─── Commission resolution ─── */
import { getFormattedImageUrl, handleImageError } from "../../../Services/ImageUrlHelper";
import ArticlesLoader from "../../../components/ArticlesLoader";
function resolveCommission(rules: any[], myMagasin?: string, productMagasin?: string): number {
  const glob = rules.find((r: any) => r.commission_type === 'global');
  return glob ? parseFloat(glob.commission_value) || 0 : 0;
}
function calcPrice(price: any, pct: number): string {
  const p = parseFloat(String(price).replace(',', '.'));
  if (isNaN(p)) return '0.00';
  const total = p + (p * pct / 100);
  const truncated = Math.floor(total * 100 + 0.00001) / 100;
  return truncated.toFixed(2);
}

export interface ProductType {
  product: ArticleInfo[];
  messageErrors: string;
}

export default function ProduitMagasin() {
  const { id: paramId } = useParams<{ id: string }>();
  const magasinContext = useContext(MagasinContext);
  const MagasinId = localStorage.getItem("MagasinId");
  const MagasinName = localStorage.getItem("MagasinName");
  const id = paramId || MagasinId || magasinContext.id?.id;

  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch]           = useState("");

  const [products, setProducts]   = useState<ArticleInfo[]>([]);
  const [alldata, setAlldata]     = useState<ArticleInfo[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 20;
  const [totalPages, setTotalPages]   = useState(1);
  const [loading, setLoading]         = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [Refs, setRef]                = useState<any[]>([]);
  const [screenW, setScreenW]         = useState(window.innerWidth);
  const isMobile = screenW <= 768;

  /* ─── New States for Edit / Delete / Multiselect ─── */
  const [selectedProducts, setSelectedProducts] = useState<string[]>([]);
  const [openMenuId, setOpenMenuId] = useState<string | null>(null);
  const [editProduct, setEditProduct] = useState<ArticleInfo | null>(null);
  const [deleteProductId, setDeleteProductId] = useState<string | null>(null);

  useEffect(() => {
    const onResize = () => setScreenW(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const fetchProducts = async (page = 1, append = false) => {
    try {
      append ? setLoadingMore(true) : setLoading(true);
      // Fetches only products for the connected magasin
      const res = await AfficheArticleInMagasin().getArticleMagasin(id);
      let allMagasinProducts = res.data || [];
      if (!Array.isArray(allMagasinProducts)) {
        if (res.data.data) allMagasinProducts = res.data.data;
        else allMagasinProducts = [];
      }
      
      const startIndex = (page - 1) * recordsPerPage;
      const endIndex = startIndex + recordsPerPage;
      const paginated = allMagasinProducts.slice(startIndex, endIndex);

      setProducts(prev => append ? [...prev, ...paginated] : paginated);
      setCurrentPage(page);
      setTotalPages(Math.ceil(allMagasinProducts.length / recordsPerPage));
      if (!append) setAlldata(allMagasinProducts);
    } catch (err) {
      console.error("Error fetching products: ", err);
    } finally {
      setLoading(false); setLoadingMore(false);
    }
  };

  useEffect(() => {
    fetchProducts(1, false);
  }, []);

  const [commRules, setCommRules] = useState<any[]>([]);
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_PHP_APP_URL}/admin/commission`)
      .then(r => setCommRules(r.data || []))
      .catch(() => setCommRules([]));
  }, []);
  const getComm = (proMagasin: string) => resolveCommission(commRules, MagasinName || '', proMagasin || '');

  const filterArticles = (list: ArticleInfo[], term: string) => {
    const t = term.toLowerCase().trim();
    const cleanT = t.replace(/[^a-z0-9]/g, '');
    return list.filter(pro => {
      const des = (pro.Designation || '').toLowerCase();
      const ref = (pro.RefArticle || '').toLowerCase();
      const cleanRef = ref.replace(/[^a-z0-9]/g, '');
      const desAr = (pro.DesignationAr || '').toLowerCase();
      const marque = ((pro as any).NomMarque || (pro as any).Marque || (pro as any).Categorie || '').toLowerCase();
      return des.includes(t) ||
             ref.includes(t) ||
             (cleanT !== '' && cleanRef.includes(cleanT)) ||
             desAr.includes(t) ||
             marque.includes(t);
    });
  };

  const getRef = async (searchTerm: string, page: number = 1, append = false) => {
    try {
      if (searchTerm.trim() === "") {
        setRef([]); setTotalPages(1); setCurrentPage(1); return;
      }
      append ? setLoadingMore(true) : setLoading(true);

      let matching: any[] = [];
      if (alldata && alldata.length > 0) {
        matching = filterArticles(alldata, searchTerm);
      } else {
        const response = await axios.post(
          `${process.env.REACT_APP_PHP_APP_URL}/search-article-magasin`,
          { q: searchTerm, id: id, magasinName: MagasinName }
        );
        matching = Array.isArray(response.data) ? response.data : [];
      }

      const startIndex = (page - 1) * recordsPerPage;
      const endIndex = startIndex + recordsPerPage;
      const paginated = matching.slice(startIndex, endIndex);

      setRef(prev => append ? [...prev, ...paginated] : paginated);
      setCurrentPage(page);
      setTotalPages(Math.max(1, Math.ceil(matching.length / recordsPerPage)));
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false); setLoadingMore(false);
    }
  };

  const goToPage = (newPage: number) => {
    if (newPage < 1 || newPage > totalPages) return;
    if (search) {
      getRef(search, newPage, false);
    } else {
      if (alldata.length > 0) {
        const startIndex = (newPage - 1) * recordsPerPage;
        const paginated = alldata.slice(startIndex, startIndex + recordsPerPage);
        setProducts(paginated);
        setCurrentPage(newPage);
      } else {
        fetchProducts(newPage, false);
      }
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchInput(e.target.value);
  };

  const triggerSearch = () => {
    const val = searchInput.trim();
    setSearch(val);
    setRef([]);
    setCurrentPage(1);
    if (val.length === 0) {
      localStorage.removeItem("SaveTape");
      fetchProducts(1, false);
      return;
    }
    localStorage.setItem("SaveTape", val);
    getRef(val, 1, false);
  };

  const handleSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") triggerSearch();
  };

  const clearSearch = () => {
    setSearch(""); setSearchInput("");
    localStorage.removeItem("SaveTape");
    setRef([]); setCurrentPage(1); setTotalPages(1);
    fetchProducts(1, false);
  };

  const handleLoadMore = () => {
    if (currentPage >= totalPages) return;
    if (search) getRef(search, currentPage + 1, true);
    else fetchProducts(currentPage + 1, true);
  };

  const hasMore = currentPage < totalPages;

  const rawDisplayData = search ? Refs : products;
  const displayData = [...rawDisplayData].sort((a, b) => {
    const qA = parseFloat(a.Quantité || a.Qte) || 0;
    const qB = parseFloat(b.Quantité || b.Qte) || 0;
    if (qA <= 10 && qB > 10) return -1;
    if (qA > 10 && qB <= 10) return 1;
    return 0;
  });

  /* ─── Handlers for Edit/Delete/Checkboxes ─── */

  const toggleProductSelect = (productId: string) => {
    setSelectedProducts(prev => 
      prev.includes(productId) ? prev.filter(id => id !== productId) : [...prev, productId]
    );
  };

  const toggleSelectAll = () => {
    if (selectedProducts.length === displayData.length) {
      setSelectedProducts([]);
    } else {
      setSelectedProducts(displayData.map(pro => pro.RefArticle));
    }
  };

  const [editImage, setEditImage] = useState<File | null>(null);
  const [editImagePreview, setEditImagePreview] = useState<string | null>(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleSaveEdit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!editProduct) return;
    setIsEditing(true);
    try {
      const formData = new FormData();
      formData.append("Designation", editProduct.Designation || "");
      formData.append("PrixVenteArticleTTC", editProduct.PrixNetHT || editProduct.PrixVenteArticleTTC || "0");
      formData.append("stock", editProduct.Quantité || editProduct.Qte || "0");
      formData.append("RefArticle", editProduct.RefArticle || "");
      if (editImage) {
        formData.append("image", editImage);
      }
      
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/magasins/${id}/articles/${encodeURIComponent(editProduct.RefArticle)}/edit`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setEditProduct(null);
      setEditImage(null);
      setEditImagePreview(null);
      setSuccessMessage("L'article a été modifié avec succès !");
      setTimeout(() => setSuccessMessage(""), 3000);
      fetchProducts(1, false);
    } catch (err) {
      console.error(err);
      alert("Erreur lors de la modification");
    } finally {
      setIsEditing(false);
    }
  };

  const handleDeleteConfirm = async () => {
    setIsDeleting(true);
    try {
      if (selectedProducts.length > 0) {
        for (const prodRef of selectedProducts) {
          await axios.delete(`${process.env.REACT_APP_PHP_APP_URL}/magasins/${id}/articles/${encodeURIComponent(prodRef)}/delete`);
        }
        setSelectedProducts([]);
      } else if (deleteProductId) {
        await axios.delete(`${process.env.REACT_APP_PHP_APP_URL}/magasins/${id}/articles/${encodeURIComponent(deleteProductId)}/delete`);
      }
      setDeleteProductId(null);
      setSuccessMessage("Suppression effectuée avec succès !");
      setTimeout(() => setSuccessMessage(""), 3000);
      fetchProducts(1, false);
    } catch (err) {
      console.error(err);
      alert("Erreur lors de la suppression");
    } finally {
      setIsDeleting(false);
    }
  };

  // ── Styles ──
  const styles = {
    pageContainer: {
      maxWidth: "1600px",
      margin: "0 auto",
      padding: "40px 24px",
      fontFamily: "'Outfit', -apple-system, BlinkMacSystemFont, sans-serif",
    },
    searchSection: {
      background: "#ffffff",
      borderRadius: "16px",
      padding: "28px",
      marginBottom: "32px",
      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e5e7eb",
      display: "flex",
      gap: "16px",
      alignItems: "center",
      flexWrap: "wrap" as const,
    },
    searchContainer: {
      position: "relative" as const,
      flex: "1 1 400px",
      minWidth: "300px",
    },
    searchIcon: {
      position: "absolute" as const,
      left: "16px",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#6b7280",
      fontSize: "1.1rem",
      cursor: "pointer",
      zIndex: 2,
    },
    searchInput: {
      width: "100%",
      padding: "14px 16px 14px 48px",
      border: "2px solid #e5e7eb",
      borderRadius: "12px",
      fontSize: "0.95rem",
      fontFamily: "'Outfit', sans-serif",
      fontWeight: 500,
      color: "#1a1a1a",
      background: "#ffffff",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      boxSizing: "border-box" as const,
    },
    addButton: {
      display: "inline-flex",
      alignItems: "center",
      gap: "10px",
      padding: "14px 24px",
      background: "linear-gradient(135deg, #ffc400 0%, #e6b000 100%)",
      border: "none",
      borderRadius: "12px",
      fontSize: "0.95rem",
      fontWeight: 700,
      color: "#1a1a1a",
      textDecoration: "none",
      cursor: "pointer",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      boxShadow: "0 4px 6px -1px rgba(255, 196, 0, 0.3)",
      fontFamily: "'Outfit', sans-serif",
    },
    productsGrid: {
      display: "flex",
      flexDirection: "column" as const,
      gap: "24px",
      marginBottom: "40px",
    },
    productCard: {
      background: "#ffffff",
      borderRadius: "16px",
      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
      border: "1px solid #e5e7eb",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      position: "relative" as const,
      animation: "fadeInUp 0.6s ease backwards",
      overflow: "visible",
    },
    checkboxContainer: {
      position: "absolute" as const,
      top: "16px",
      left: "16px",
      zIndex: 10,
    },
    moreIcon: {
      position: "absolute" as const,
      top: "16px",
      right: "16px",
      width: "40px",
      height: "40px",
      background: "rgba(255, 255, 255, 0.95)",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "1.3rem",
      color: "#6b7280",
      cursor: "pointer",
      transition: "all 0.3s ease",
      zIndex: 10,
      backdropFilter: "blur(10px)",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
    dropdownMenu: {
      position: "absolute" as const,
      top: "60px",
      right: "16px",
      background: "#fff",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      borderRadius: "8px",
      zIndex: 100,
      display: "flex",
      flexDirection: "column" as const,
      minWidth: "120px",
      overflow: "hidden"
    },
    dropdownItem: {
      padding: "10px 16px",
      cursor: "pointer",
      fontSize: "0.95rem",
      fontWeight: 500,
      color: "#333",
      transition: "background 0.2s",
      textAlign: "left" as const,
      border: "none",
      background: "transparent",
      display: "flex",
      alignItems: "center",
      gap: "8px"
    },
    productLink: {
      textDecoration: "none",
      color: "inherit",
      display: "flex",
      alignItems: "center",
      padding: "20px 20px 20px 50px", // extra left padding for checkbox
      gap: "24px",
    },
    imageContainer: {
      position: "relative" as const,
      width: "240px",
      height: "200px",
      flexShrink: 0,
      background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
      borderRadius: "12px",
      overflow: "hidden",
      border: "1px solid #e5e7eb",
    },
    productImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover" as const,
      transition: "transform 0.5s ease",
    },
    priceTag: {
      position: "absolute" as const,
      bottom: "0",
      left: "0",
      right: "0",
      background: "linear-gradient(135deg, #ffc400 0%, #e6b000 100%)",
      color: "#1a1a1a",
      padding: "10px 14px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 700,
      fontSize: "1rem",
      fontFamily: "'Outfit', sans-serif",
      borderRadius: "0 0 12px 12px",
    },
    priceUnit: {
      fontSize: "0.7rem",
      fontWeight: 500,
      color: "#3b3b3b",
      marginLeft: "6px",
    },
    productInfo: {
      flex: 1,
      display: "flex",
      flexDirection: "column" as const,
      justifyContent: "center",
      paddingRight: "60px",
    },
    productTitle: {
      fontSize: "1.25rem",
      fontWeight: 600,
      color: "#1a1a1a",
      lineHeight: "1.5",
      marginBottom: "16px",
      fontFamily: "'Outfit', sans-serif",
    },
    salesBadge: {
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      background: "rgba(255, 196, 0, 0.15)",
      color: "#d97706",
      padding: "8px 16px",
      borderRadius: "20px",
      fontSize: "0.9rem",
      fontWeight: 600,
      fontFamily: "'Outfit', sans-serif",
      width: "fit-content",
    },
    emptyState: {
      textAlign: "center" as const,
      padding: "80px 40px",
      background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
      borderRadius: "20px",
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
      margin: "60px auto",
      maxWidth: "600px",
    },
    emptyIcon: {
      fontSize: "5rem",
      color: "#d1d5db",
      marginBottom: "24px",
      display: "block",
    },
    emptyText: {
      fontSize: "1.2rem",
      color: "#6b7280",
      marginBottom: "32px",
      fontWeight: 500,
      fontFamily: "'Outfit', sans-serif",
      lineHeight: "1.6",
    },
    loaderContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "400px",
    },
    spinner: {
      width: "60px",
      height: "60px",
      border: "5px solid #e5e7eb",
      borderTop: "5px solid #ffc400",
      borderRadius: "50%",
      animation: "spin 1s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite",
      marginRight: "20px",
    },
    loaderText: {
      fontSize: "1.2rem",
      color: "#ffc400",
      fontWeight: 700,
      fontFamily: "'Outfit', sans-serif",
    },
    modalOverlay: {
      position: "fixed" as const,
      top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(15, 23, 42, 0.4)",
      backdropFilter: "blur(8px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
      animation: "fadeIn 0.3s ease",
    },
    modalContent: {
      background: "#ffffff",
      padding: "40px",
      borderRadius: "24px",
      width: "100%",
      maxWidth: "520px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      position: "relative" as const,
      animation: "slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
    },
    modalTitle: {
      marginBottom: "24px",
      fontSize: "1.5rem",
      fontWeight: 700,
      color: "#1e293b",
      display: "flex",
      alignItems: "center",
      gap: "12px"
    },
    inputGroup: {
      marginBottom: "20px"
    },
    label: {
      display: "block",
      marginBottom: "8px",
      fontWeight: 600,
      fontSize: "0.95rem",
      color: "#475569"
    },
    input: {
      width: "100%",
      padding: "14px 16px",
      border: "2px solid #e2e8f0",
      borderRadius: "12px",
      fontSize: "1rem",
      color: "#1e293b",
      transition: "all 0.2s ease",
      fontFamily: "'Outfit', sans-serif",
      backgroundColor: "#f8fafc",
    },
    modalActions: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "16px",
      marginTop: "32px"
    },
    btnCancel: {
      padding: "12px 24px",
      background: "#f1f5f9",
      color: "#64748b",
      border: "none",
      borderRadius: "12px",
      cursor: "pointer",
      fontWeight: 600,
      fontSize: "1rem",
      transition: "all 0.2s ease",
      fontFamily: "'Outfit', sans-serif",
    },
    btnSave: {
      padding: "12px 24px",
      background: "linear-gradient(135deg, #ffc400 0%, #e6b000 100%)",
      color: "#1a1a1a",
      border: "none",
      borderRadius: "12px",
      cursor: "pointer",
      fontWeight: 700,
      fontSize: "1rem",
      boxShadow: "0 4px 12px rgba(255, 196, 0, 0.3)",
      transition: "all 0.2s ease",
      fontFamily: "'Outfit', sans-serif",
      display: "flex",
      alignItems: "center",
      gap: "8px"
    },
    btnDeleteBulk: {
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      padding: "14px 24px",
      background: "#ef4444",
      color: "white",
      border: "none",
      borderRadius: "12px",
      fontWeight: 600,
      fontSize: "0.95rem",
      cursor: "pointer",
      boxShadow: "0 4px 12px rgba(239, 68, 68, 0.3)",
      transition: "all 0.2s",
      fontFamily: "'Outfit', sans-serif",
    },
    fileUploadZone: {
      position: "relative" as const,
      border: "2px dashed #cbd5e1",
      borderRadius: "12px",
      padding: "24px",
      textAlign: "center" as const,
      background: "#f8fafc",
      cursor: "pointer",
      transition: "all 0.2s ease",
      display: "flex",
      flexDirection: "column" as const,
      alignItems: "center",
      gap: "8px",
    },
    fileUploadInput: {
      position: "absolute" as const,
      top: 0, left: 0, width: "100%", height: "100%",
      opacity: 0, cursor: "pointer",
    },
    toastSuccess: {
      position: "fixed" as const,
      bottom: "40px",
      left: "50%",
      transform: "translateX(-50%)",
      background: "#10b981",
      color: "white",
      padding: "16px 32px",
      borderRadius: "100px",
      display: "flex",
      alignItems: "center",
      gap: "12px",
      boxShadow: "0 10px 25px rgba(16, 185, 129, 0.4)",
      zIndex: 2000,
      fontWeight: 600,
      fontSize: "1.05rem",
      animation: "toastSlideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
    }
  };

  const globalStyles = `
    @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap');
    @keyframes fadeInUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
    @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
    @keyframes slideUp { from { opacity: 0; transform: translateY(40px) scale(0.95); } to { opacity: 1; transform: translateY(0) scale(1); } }
    @keyframes toastSlideUp { 0% { opacity: 0; transform: translate(-50%, 40px); } 100% { opacity: 1; transform: translate(-50%, 0); } }
    @keyframes spin { to { transform: rotate(360deg); } }
    input:focus { outline: none !important; border-color: #ffc400 !important; box-shadow: 0 0 0 3px rgba(255, 196, 0, 0.15) !important; background: #ffffff !important; }
    .dropdownItem:hover { background: #f8fafc; }
    .product-card-hover:hover { transform: translateY(-8px); box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.15); border-color: #ffc400; }
    .product-card-hover:hover .product-image { transform: scale(1.08); }
    .more-icon-hover:hover { background: #ffc400 !important; color: #1a1a1a !important; transform: scale(1.1); }
    .add-button-hover:hover { transform: translateY(-2px); box-shadow: 0 10px 15px -3px rgba(255, 196, 0, 0.4); }
    .btn-cancel-hover:hover { background: #e2e8f0 !important; color: #334155 !important; }
    .btn-save-hover:hover { transform: translateY(-2px); box-shadow: 0 6px 16px rgba(255, 196, 0, 0.4) !important; }
    .btn-delete-hover:hover { transform: translateY(-2px); box-shadow: 0 6px 16px rgba(239, 68, 68, 0.4) !important; }
    .file-upload-hover:hover { border-color: #ffc400 !important; background: #fffbeb !important; }
    .small-spinner { width: 18px; height: 18px; border: 3px solid rgba(0,0,0,0.1); border-top-color: currentColor; border-radius: 50%; animation: spin 0.8s linear infinite; }
  `;

  const renderProducts = () => {
    if (displayData && displayData.length > 0) {
      return displayData.map((pro, index) => {
        const productRef = pro.RefArticle;
        const encodedRef = btoa(pro.RefArticle);
        const isOpen = openMenuId === productRef;

        return (
          <div key={productRef}
            style={{ ...styles.productCard, animationDelay: `${index * 0.1}s` }}
            className="product-card-hover">
            
            {/* Checkbox */}
            <div style={styles.checkboxContainer}>
              <input 
                type="checkbox" 
                checked={selectedProducts.includes(productRef)}
                onChange={() => toggleProductSelect(productRef)}
                style={{ width: "20px", height: "20px", cursor: "pointer" }}
              />
            </div>

            {/* 3 Dots Menu */}
            <div 
              style={styles.moreIcon} 
              className="more-icon-hover"
              onClick={(e) => {
                e.preventDefault();
                setOpenMenuId(isOpen ? null : productRef);
              }}
            >
              <i className="bi bi-three-dots-vertical" />
            </div>

            {isOpen && (
              <div style={styles.dropdownMenu}>
                <button 
                  className="dropdownItem"
                  style={styles.dropdownItem}
                  onClick={() => {
                    setEditProduct(pro);
                    setOpenMenuId(null);
                  }}
                >
                  <i className="bi bi-pencil" /> Modifier
                </button>
                <button 
                  className="dropdownItem"
                  style={{...styles.dropdownItem, color: "#ef4444"}}
                  onClick={() => {
                    setDeleteProductId(productRef);
                    setOpenMenuId(null);
                  }}
                >
                  <i className="bi bi-trash" /> Supprimer
                </button>
              </div>
            )}

            <Link
              style={{
                ...styles.productLink,
                flexDirection: isMobile ? "column" : "row",
                alignItems: isMobile ? "stretch" : "center",
                gap: isMobile ? "12px" : "24px",
                padding: isMobile ? "12px" : "20px 20px 20px 50px",
              }}
              to={`/magasins/${id}/${pro.NomMagasin || MagasinName}/articles/${encodedRef}`}
            >
              <div
                style={{
                  ...styles.imageContainer,
                  width: isMobile ? "100%" : "240px",
                  height: isMobile ? "190px" : "200px",
                }}
              >
                <img
                  src={getFormattedImageUrl(pro.urlImage || (pro as any).UrlImage || (pro as any).image || (pro as any).Image || (pro as any).imageUrl)}
                  alt={pro.Designation}
                  style={styles.productImage}
                  className="product-image"
                  onError={handleImageError}
                />
                <div style={styles.priceTag}>
                  <span>{(parseFloat(String(pro.PrixNetHT || pro.PrixVenteArticleTTC || pro.prix_ht_1_magasin || pro.prix || 0).replace(',', '.')) || 0).toFixed(2)} MAD<span style={styles.priceUnit}>/ p.u</span></span>
                </div>
              </div>
              <div style={{ ...styles.productInfo, paddingRight: isMobile ? "0" : "60px" }}>
                <div style={{ marginBottom: "6px" }}>
                  <span style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                    background: "#FEF3C7",
                    color: "#92400E",
                    padding: "3px 8px",
                    borderRadius: "6px",
                    fontSize: "0.82rem",
                    fontWeight: 700,
                    letterSpacing: "0.02em"
                  }}>
                    <i className="bi bi-hash" style={{ color: "#D97706" }} />
                    Réf : {pro.RefArticle || "N/A"}
                  </span>
                </div>
                <h3 style={{ ...styles.productTitle, fontSize: isMobile ? "1rem" : "1.25rem", marginBottom: isMobile ? "10px" : "16px" }}>
                  {pro.Designation}{pro.DesignationAr ? ` | ${pro.DesignationAr}` : ""}
                </h3>
                <div className="d-flex flex-wrap gap-2">
                  <div style={styles.salesBadge}><i className="bi bi-box" /> Stock: {pro.Quantité || pro.Qte || 0}</div>
                </div>
              </div>
            </Link>
          </div>
        );
      });
    }

    return (
      <div style={styles.emptyState}>
        <i className="bi bi-emoji-neutral" style={styles.emptyIcon} />
        <p style={styles.emptyText}>Malheureusement, on n'a pas ce produit pour l'instant.</p>
      </div>
    );
  };

  return (
    <>
      <style>{globalStyles}</style>
      <NewSideBarMagasins />
      <div
        style={{
          ...styles.pageContainer,
          padding: isMobile ? "88px 12px 24px" : "40px 24px",
          maxWidth: isMobile ? "100%" : "1600px",
          overflowX: "hidden",
        }}
        onClick={() => { if(openMenuId) setOpenMenuId(null); }}
      >

        <div
          style={{
            ...styles.searchSection,
            padding: isMobile ? "14px" : "28px",
            marginBottom: isMobile ? "16px" : "32px",
            flexDirection: isMobile ? "column" : "row",
            alignItems: isMobile ? "stretch" : "center",
          }}
        >
          <div
            style={{
              ...styles.searchContainer,
              flex: "1 1 auto",
              minWidth: isMobile ? "100%" : "300px",
            }}
          >
            <i className="bi bi-search" style={styles.searchIcon} onClick={triggerSearch} />
            <input
              type="text"
              onChange={handleSearchInputChange}
              onKeyDown={handleSearchKeyDown}
              value={searchInput}
              placeholder="Rechercher un produit, ref..."
              style={styles.searchInput}
            />
            {searchInput && (
              <i className="bi bi-x"
                style={{ position:"absolute", right:"14px", top:"50%", transform:"translateY(-50%)",
                  cursor:"pointer", fontSize:"1.1rem", color:"#6b7280" }}
                onClick={clearSearch} />
            )}
          </div>
          
          <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
            {selectedProducts.length > 0 && (
              <button onClick={() => setDeleteProductId('bulk')} style={styles.btnDeleteBulk}>
                <i className="bi bi-trash" /> Supprimer la sélection ({selectedProducts.length})
              </button>
            )}
            <Link
              to={`/magasins/${id}/articles/add`}
              style={{ ...styles.addButton, justifyContent: "center", width: isMobile ? "100%" : "auto" }}
              className="add-button-hover"
            >
              <i className="bi bi-plus-circle" /> Ajouter un produit
            </Link>
          </div>
        </div>

        {/* Products Grid */}
        {loading ? (
          <ArticlesLoader />
        ) : (
          <>
            {displayData.length > 0 && (
              <div style={{ marginBottom: "16px", display: "flex", alignItems: "center", gap: "8px" }}>
                <input 
                  type="checkbox" 
                  checked={selectedProducts.length === displayData.length && displayData.length > 0}
                  onChange={toggleSelectAll}
                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                />
                <span style={{ fontWeight: 600, color: "#4b5563" }}>Tout sélectionner</span>
              </div>
            )}
            
            <div style={{ ...styles.productsGrid, gap: isMobile ? "14px" : "24px" }}>{renderProducts()}</div>

            {/* Pagination Controls */}
            {totalPages > 1 && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", margin: "28px 0", flexWrap: "wrap" }}>
                <button
                  onClick={() => goToPage(currentPage - 1)}
                  disabled={currentPage <= 1 || loading || loadingMore}
                  style={{
                    padding: "8px 16px",
                    borderRadius: "8px",
                    border: "1px solid #e5e7eb",
                    background: currentPage <= 1 ? "#f3f4f6" : "#fff",
                    color: currentPage <= 1 ? "#9ca3af" : "#1f2937",
                    cursor: currentPage <= 1 ? "not-allowed" : "pointer",
                    fontWeight: 600,
                    fontSize: "0.9rem"
                  }}
                >
                  <i className="bi bi-chevron-left" /> Précédent
                </button>

                {Array.from({ length: totalPages }, (_, i) => i + 1)
                  .filter(p => p === 1 || p === totalPages || Math.abs(p - currentPage) <= 2)
                  .map((p, idx, arr) => {
                    const prevP = arr[idx - 1];
                    const showEllipsis = prevP && p - prevP > 1;
                    return (
                      <span key={p} style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
                        {showEllipsis && <span style={{ padding: "0 4px", color: "#9ca3af" }}>...</span>}
                        <button
                          onClick={() => goToPage(p)}
                          style={{
                            padding: "8px 14px",
                            borderRadius: "8px",
                            border: p === currentPage ? "1px solid #ffc400" : "1px solid #e5e7eb",
                            background: p === currentPage ? "#ffc400" : "#fff",
                            color: p === currentPage ? "#1a1a1a" : "#4b5563",
                            fontWeight: p === currentPage ? 700 : 500,
                            cursor: "pointer",
                            fontSize: "0.9rem"
                          }}
                        >
                          {p}
                        </button>
                      </span>
                    );
                  })}

                <button
                  onClick={() => goToPage(currentPage + 1)}
                  disabled={currentPage >= totalPages || loading || loadingMore}
                  style={{
                    padding: "8px 16px",
                    borderRadius: "8px",
                    border: "1px solid #ffc400",
                    background: currentPage >= totalPages ? "#f3f4f6" : "#ffc400",
                    color: currentPage >= totalPages ? "#9ca3af" : "#1a1a1a",
                    cursor: currentPage >= totalPages ? "not-allowed" : "pointer",
                    fontWeight: 700,
                    fontSize: "0.9rem"
                  }}
                >
                  Suivant <i className="bi bi-chevron-right" />
                </button>
              </div>
            )}

            {hasMore && displayData.length > 0 && (
              <div style={{ display:"flex", justifyContent:"center", margin:"12px 0 28px 0" }}>
                <button
                  onClick={handleLoadMore}
                  disabled={loadingMore}
                  style={{
                    padding: "12px 36px",
                    background: loadingMore ? "#e5e7eb" : "linear-gradient(135deg, #ffc400 0%, #e6b000 100%)",
                    border: "none",
                    borderRadius: "12px",
                    fontWeight: 700,
                    fontSize: "0.95rem",
                    color: "#1a1a1a",
                    cursor: loadingMore ? "not-allowed" : "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    fontFamily: "'Outfit', sans-serif",
                    boxShadow: "0 4px 6px -1px rgba(255, 196, 0, 0.3)",
                    transition: "all 0.2s",
                  }}
                >
                  {loadingMore ? "Chargement…" : "Voir plus d'articles"}
                </button>
              </div>
            )}
          </>
        )}
      </div>

      {/* Edit Modal */}
      {editProduct && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <div style={styles.modalTitle}>
              <div style={{background: "#fffbeb", padding: "10px", borderRadius: "12px", color: "#d97706"}}>
                <i className="bi bi-pencil-square" style={{fontSize: "1.2rem"}}/>
              </div>
              Modifier l'article
              <button
                type="button"
                onClick={() => { setEditProduct(null); setEditImage(null); setEditImagePreview(null); }}
                style={{marginLeft: "auto", background: "none", border: "none", cursor: "pointer", color: "#94a3b8", fontSize: "1.3rem", lineHeight: 1}}
              >
                <i className="bi bi-x-lg" />
              </button>
            </div>
            <form onSubmit={handleSaveEdit}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Désignation</label>
                <input 
                  type="text" 
                  value={editProduct.Designation || ""} 
                  onChange={e => setEditProduct({...editProduct, Designation: e.target.value})}
                  style={styles.input}
                  required
                />
              </div>
              <div style={{display: "flex", gap: "16px", marginBottom: "20px"}}>
                <div style={{flex: 1}}>
                  <label style={styles.label}>Prix (Net)</label>
                  <input 
                    type="number" 
                    step="0.01"
                    value={editProduct.PrixNetHT || editProduct.PrixVenteArticleTTC || ""} 
                    onChange={e => setEditProduct({...editProduct, PrixNetHT: e.target.value})}
                    style={styles.input}
                    required
                  />
                </div>
                <div style={{flex: 1}}>
                  <label style={styles.label}>Quantité en stock</label>
                  <input 
                    type="number" 
                    value={editProduct.Quantité || editProduct.Qte || ""} 
                    onChange={e => setEditProduct({...editProduct, Quantité: e.target.value})}
                    style={styles.input}
                    required
                  />
                </div>
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Image de l'article (Optionnel)</label>

                {/* Current image preview */}
                {(editImagePreview || editProduct.urlImage || (editProduct as any).UrlImage || (editProduct as any).image || (editProduct as any).Image) && (
                  <div style={{marginBottom: "12px", textAlign: "center" as const}}>
                    <img
                      src={editImagePreview || getFormattedImageUrl(editProduct.urlImage || (editProduct as any).UrlImage || (editProduct as any).image || (editProduct as any).Image)}
                      alt="preview"
                      onError={handleImageError}
                      style={{
                        width: "100%",
                        maxHeight: "160px",
                        objectFit: "contain",
                        borderRadius: "12px",
                        border: "2px solid #e2e8f0",
                        background: "#f8fafc",
                        padding: "8px"
                      }}
                    />
                    {editImagePreview && (
                      <span style={{fontSize: "0.8rem", color: "#10b981", fontWeight: 600, display: "block", marginTop: "6px"}}>
                        <i className="bi bi-check-circle" /> Nouvelle image sélectionnée
                      </span>
                    )}
                  </div>
                )}

                {/* Upload zone */}
                <div style={styles.fileUploadZone} className="file-upload-hover">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={e => {
                      if (e.target.files && e.target.files[0]) {
                        const file = e.target.files[0];
                        setEditImage(file);
                        setEditImagePreview(URL.createObjectURL(file));
                      }
                    }}
                    style={styles.fileUploadInput}
                  />
                  <div style={{
                    width: "48px", height: "48px",
                    background: "linear-gradient(135deg, #fffbeb, #fef3c7)",
                    borderRadius: "12px",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    marginBottom: "4px"
                  }}>
                    <i className="bi bi-cloud-arrow-up" style={{fontSize: "1.5rem", color: "#d97706"}} />
                  </div>
                  <span style={{fontWeight: 700, color: "#1e293b", fontSize: "0.95rem"}}>
                    {editImage ? "Changer la photo" : "Ajouter une photo"}
                  </span>
                  <span style={{color: "#94a3b8", fontSize: "0.82rem"}}>Cliquez ou glissez un fichier ici</span>
                  <span style={{
                    marginTop: "6px",
                    padding: "4px 14px",
                    background: "linear-gradient(135deg, #ffc400, #e6b000)",
                    borderRadius: "100px",
                    fontSize: "0.82rem",
                    fontWeight: 700,
                    color: "#1a1a1a",
                    boxShadow: "0 2px 8px rgba(255,196,0,0.3)"
                  }}>Parcourir</span>
                  <span style={{color: "#cbd5e1", fontSize: "0.78rem"}}>PNG, JPG, WEBP jusqu'à 5 MB</span>
                </div>
              </div>
              <div style={styles.modalActions}>
                <button type="button" onClick={() => { setEditProduct(null); setEditImage(null); setEditImagePreview(null); }} style={styles.btnCancel} className="btn-cancel-hover" disabled={isEditing}>Annuler</button>
                <button type="submit" style={styles.btnSave} className="btn-save-hover" disabled={isEditing}>
                  {isEditing ? <><div className="small-spinner" /> Enregistrement...</> : "Enregistrer les modifications"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {deleteProductId && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <div style={{...styles.modalTitle, color: "#ef4444"}}>
              <div style={{background: "#fef2f2", padding: "10px", borderRadius: "12px"}}>
                <i className="bi bi-exclamation-triangle" style={{fontSize: "1.2rem"}}/>
              </div>
              Confirmer la suppression
            </div>
            <p style={{ marginBottom: "32px", color: "#64748b", fontSize: "1.05rem", lineHeight: "1.6" }}>
              Êtes-vous sûr de vouloir supprimer {deleteProductId === 'bulk' ? <strong style={{color:"#1e293b"}}>ces {selectedProducts.length} articles</strong> : <strong style={{color:"#1e293b"}}>cet article</strong>} ?
              <br/>Cette action est irréversible et supprimera le produit définitivement.
            </p>
            <div style={styles.modalActions}>
              <button onClick={() => setDeleteProductId(null)} style={styles.btnCancel} className="btn-cancel-hover" disabled={isDeleting}>Annuler</button>
              <button onClick={handleDeleteConfirm} style={{...styles.btnSave, background: "#ef4444", color: "white", boxShadow: "0 4px 12px rgba(239, 68, 68, 0.3)"}} className="btn-delete-hover" disabled={isDeleting}>
                {isDeleting ? <><div className="small-spinner" /> Suppression...</> : "Oui, supprimer"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Success Toast Popup */}
      {successMessage && (
        <div style={styles.toastSuccess}>
          <i className="bi bi-check-circle-fill" style={{fontSize: "1.3rem"}} />
          {successMessage}
        </div>
      )}

    </>
  );
}